import * as React from 'react'

import { action, makeObservable } from 'mobx'
import { inject, observer } from 'mobx-react'

import ActionBarInput from '~/client/src/shared/components/ActionBarInput/ActionBarInput'
import { Button } from '~/client/src/shared/components/shadcn-ui/button'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import Photo from '~/client/src/shared/models/Photo'
import RootStore from '~/client/src/shared/stores/Root.store'
import SlackBarStore from '~/client/src/shared/stores/ui/SlackBar.store'

// translated

interface IProps {
  photo: Photo
  store?: SlackBarStore
}

@inject((store: RootStore) => {
  return {
    store: store.slackBarStore,
  }
})
@observer
export default class ActionBar extends React.Component<IProps> {
  private isSending: boolean

  public constructor(props: IProps) {
    super(props)
    makeObservable(this)
  }

  public render() {
    return (
      <div className="pa10 bt-light-grey slack-bar">
        <form onSubmit={this.send}>
          <div className="col">
            <ActionBarInput
              value={this.props.store.draftMessage}
              onChange={this.setDraftMessage}
              placeholder={Localization.translator.addANote}
            />
            <div className="tw:flex tw:justify-end">
              <Button
                variant="primary-outline"
                type="submit"
                disabled={this.isSending}
              >
                {Localization.translator.send}
              </Button>
            </div>
          </div>
        </form>
      </div>
    )
  }

  @action.bound
  private async send(evt: React.FormEvent<HTMLFormElement>) {
    this.isSending = true
    evt.preventDefault()
    evt.stopPropagation()
    await this.props.store.replyToPhoto(this.props.photo)
    this.isSending = false
  }

  @action
  private setDraftMessage = (evt: React.FormEvent<HTMLInputElement>) => {
    this.props.store.draftMessage = evt.currentTarget.value
  }
}
